module.exports = __webpack_public_path__ + "fonts/Roboto-Thin.woff";


//////////////////
// WEBPACK FOOTER
// ./src/common/fonts/Roboto/Roboto-Thin.woff
// module id = 3462
// module chunks = 0